module.exports = __webpack_public_path__ + "static/media/SWSCRC6-4.ea8f6f13.mp3";